import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getTeamMessages, removeTeamMessage, updateTeamMessage } from 'slice/teamMessageSlice';
import AdminTable from 'common/AdminTable';

const ListTeamMessage = () => {
  const dispatch = useDispatch();
  const ASSET_BASE_URL = process.env.REACT_APP_BACKEND_URL_REL;

  const { data: messageList } = useSelector((state) => state.teamMessage);

  const [showModal, setShowModal] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [formData, setFormData] = useState({
    title: '',
    type: 'horizontal',
    is_active: true,
    image: null,
    video: null,
    video_url: '',
    existingImage: '',
    existingVideo: ''
  });

  // Fetch list on mount
  useEffect(() => {
    dispatch(getTeamMessages());
  }, [dispatch]);

  // Edit button click
  const handleEditClick = (message) => {
    setSelectedMessage(message);
    setFormData({
      title: message.title,
      type: message.type || 'horizontal',
      is_active: message.is_active === 0 ? false : true,
      image: null,
      video: null,
      video_url: message.video_url || '',
      existingImage: message.image ? `${ASSET_BASE_URL}messages/${message.image}` : '',
      existingVideo: message.video ? `${ASSET_BASE_URL}messages/${message.video}` : ''
    });
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedMessage(null);
  };

  const handleFormChange = (e) => {
    const { name, value, files, checked } = e.target;
    if (name === 'image') {
      setFormData((prev) => ({ ...prev, image: files[0] }));
    } else if (name === 'video') {
      setFormData((prev) => ({ ...prev, video: files[0] }));
    } else if (name === 'is_active') {
      setFormData((prev) => ({ ...prev, is_active: checked }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const isVideoType = formData.type === 'video';

  const handleSaveChanges = () => {
    if (!selectedMessage) return;

    const data = new FormData();
    data.append('title', formData.title);
    data.append('type', formData.type);
    data.append('is_active', formData.is_active ? 1 : 0);

    if (formData.video_url) {
      data.append('video_url', formData.video_url);
    }

    if (formData.image) {
      data.append('image', formData.image);
    }

    if (formData.video) {
      data.append('video', formData.video);
    }

    dispatch(updateTeamMessage({ id: selectedMessage.id, data }));
    closeModal(); // saga handles toast + refresh
  };

  const tableHeaders = [
    { Header: 'ID', accessor: 'id' },
    {
      Header: 'Image',
      accessor: 'image',
      Cell: ({ row }) =>
        row.original.image ? (
          <img
            src={`${ASSET_BASE_URL}messages/${row.original.image}`}
            alt={row.original.title}
            width={100}
            onError={(e) => (e.currentTarget.src = '/no-image.png')}
          />
        ) : (
          <span className="text-muted">—</span>
        )
    },
    { Header: 'Title', accessor: 'title' },
    { Header: 'Type', accessor: 'type' },
    {
      Header: 'Active',
      accessor: 'is_active',
      Cell: ({ row }) => (
        <span className={`badge ${row.original.is_active ? 'badge-success' : 'badge-secondary'}`}>
          {row.original.is_active ? 'Yes' : 'No'}
        </span>
      )
    },
    {
      Header: 'Actions',
      accessor: 'actions',
      Cell: ({ row }) => (
        <>
          <button className="btn btn-danger mx-1" onClick={() => dispatch(removeTeamMessage(row.original.id))}>
            Remove
          </button>
          <button className="btn btn-primary mx-1" onClick={() => handleEditClick(row.original)}>
            Edit
          </button>
        </>
      )
    }
  ];

  return (
    <>
      <div className="container-fluid mt-5">
        <div className="mainheadig mx-4">
          <h4 className="text-white font-weight-bold">Advertisement List</h4>
        </div>
        {messageList?.length > 0 && <AdminTable tableHeaders={tableHeaders} tableData={messageList} />}
      </div>

      {/* Modal */}
      {showModal && selectedMessage && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Edit Advertisement</h5>
                <button type="button" className="close" onClick={closeModal}>
                  <span>&times;</span>
                </button>
              </div>

              <div className="modal-body">
                <label htmlFor="editTitle" className="font-weight-bold">Title</label>
                <input
                  id="editTitle"
                  type="text"
                  name="title"
                  value={formData.title}
                  onChange={handleFormChange}
                  placeholder="Title"
                  className="form-control mb-2"
                />

                <label htmlFor="editType" className="font-weight-bold">Type</label>
                <select id="editType" name="type" value={formData.type} onChange={handleFormChange} className="form-control mb-2">
                  <option value="horizontal">Horizontal</option>
                  <option value="vertical">Vertical</option>
                  <option value="video">Video</option>
                </select>

                {!isVideoType && (
                  <>
                    <label htmlFor="editImage" className="font-weight-bold">Image</label>
                    <input id="editImage" type="file" name="image" onChange={handleFormChange} className="form-control mb-2" />
                    {formData.image ? (
                      <img src={URL.createObjectURL(formData.image)} width={100} alt="preview" className="mb-2" />
                    ) : formData.existingImage ? (
                      <img src={formData.existingImage} width={100} alt="existing" className="mb-2" />
                    ) : null}
                  </>
                )}

                {isVideoType && (
                  <>
                    <label htmlFor="editVideo" className="font-weight-bold">Video File</label>
                    <input id="editVideo" type="file" name="video" onChange={handleFormChange} className="form-control mb-2" />
                    {formData.video ? (
                      <video src={URL.createObjectURL(formData.video)} width={180} className="mb-2" controls>
                        <track kind="captions" />
                      </video>
                    ) : formData.existingVideo ? (
                      <video src={formData.existingVideo} width={180} className="mb-2" controls>
                        <track kind="captions" />
                      </video>
                    ) : null}

                    <label htmlFor="editVideoUrl" className="font-weight-bold">Video URL</label>
                    <input
                      id="editVideoUrl"
                      type="text"
                      name="video_url"
                      value={formData.video_url}
                      onChange={handleFormChange}
                      placeholder="https://youtube.com/shorts/... or https://youtu.be/..."
                      className="form-control mb-2"
                    />
                  </>
                )}

                <div className="form-check mb-2">
                  <input
                    type="checkbox"
                    id="editIsActive"
                    name="is_active"
                    checked={formData.is_active}
                    onChange={handleFormChange}
                    className="form-check-input"
                  />
                  <label htmlFor="editIsActive" className="form-check-label">
                    Active
                  </label>
                </div>
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={closeModal}>
                  Close
                </button>
                <button className="btn btn-primary" onClick={handleSaveChanges}>
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ListTeamMessage;